// @flow strict
import React from "react";
import { Link } from "gatsby";
import type { Edges } from "../../types";
import styles from "./Feed.module.scss";
import ExternalLink from "./ExternalLink";
import FeedImage from "./FeedImage";

type Props = {
  edges: Edges,
};

const Feed = ({ edges }: Props) => (
  <div className={styles["feed"]}>
    {edges.map((edge) => (
      <div className={styles["feed__item"]} key={edge.node.fields.slug}>
        <div className={styles["feed__item-meta"]}>
          {(() => {
            const rawDate = edge.node.frontmatter.date;
            const dateObj = rawDate ? new Date(rawDate) : null;
            const hasValidDate =
              dateObj instanceof Date && !Number.isNaN(dateObj.getTime());

            const category = edge.node.frontmatter.category;
            const categorySlug = edge.node.fields.categorySlug;

            return (
              <>
                {hasValidDate && (
                  <time
                    className={styles["feed__item-meta-time"]}
                    dateTime={dateObj.toISOString()}
                    title={dateObj.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  >
                    {dateObj.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                    })}
                  </time>
                )}
                {hasValidDate && category && (
                  <span className={styles["feed__item-meta-divider"]} />
                )}
                {category && (
                  <span className={styles["feed__item-meta-category"]}>
                    {categorySlug ? (
                      <Link
                        to={categorySlug}
                        className={styles["feed__item-meta-category-link"]}
                      >
                        {category}
                      </Link>
                    ) : (
                      category
                    )}
                  </span>
                )}
              </>
            );
          })()}
        </div>
        <h2 className={styles["feed__item-title"]}>
          <Link
            className={styles["feed__item-title-link"]}
            to={edge.node.fields.slug}
          >
            {edge.node.frontmatter.title}
          </Link>
        </h2>
        <FeedImage edge={edge} />
        <div
          className={styles["feed__item-description"]}
          dangerouslySetInnerHTML={{
            __html: edge.node.frontmatter.description || "",
          }}
        />
        <ExternalLink edge={edge} />
      </div>
    ))}
  </div>
);

export default Feed;
